import {Component, Input} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {IYii} from '../../../../globals';
import {Select} from 'primeng/select';
import {Checkbox} from 'primeng/checkbox';
import {LayoutOptions} from '../../constants/layout-options';
import {FieldService} from '../../services/FieldService';
import {InputText} from 'primeng/inputtext';

declare var Yii: IYii;

@Component({
  selector: 'ng-field-text-field',
  imports: [
    FormsModule,
    Select,
    Checkbox,
    InputText
  ],
  template: `
    <div class="form-row flex-align-center">
      <label>{{ Yii.t('be_forms', 'Input Type') }}</label>
      <div>
        <p-select
          [(ngModel)]="field.input_type"
          [options]="inputTypes"
          optionLabel="tag"
          optionValue="type"
          appendTo="body"
          (onChange)="change()"
        />
      </div>
    </div>
    <div class="form-row">
      <label></label>
      <div class="flex-row gap-8px flex-align-center">
        <p-checkbox
          binary="true"
          [(ngModel)]="field.canBeDuplicated"
          (onChange)="change()"
        />
        <label>
          {{ Yii.t('app', 'Can Be Duplicated') }}
        </label>
      </div>
    </div>
    <div class="form-row flex-align-center">
      <label>
        {{ Yii.t('app', 'Layout') }}
      </label>
      <div>
        <p-select
          [(ngModel)]="field.layout"
          [options]="layouts"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
          (onChange)="change()"
        />
      </div>
    </div>
    @if (field.layout === 'horizontal') {
      <div class="form-row flex-align-center">
        <label>
          {{ Yii.t('app', 'Label width %') }}
        </label>
        <div>
          <label>
            <input
              pInputText
              type="number"
              min="10"
              max="90"
              step="1"
              [(ngModel)]="field.labelWidth"
              (change)="change()"
            />
          </label>
        </div>
      </div>
    }
  `
})
export class FieldTextfield {

  Yii = Yii

  public layouts = LayoutOptions;

  public inputTypes = [
    {"tag": "Text", "type": "text"},
    {"tag": "Number", "type": "number"},
    {"tag": "Url", "type": "url"},
    {"tag": "Telephone", "type": "tel"}];

  @Input() field: any;

  constructor(public fields: FieldService) {}

  public change() {
    this.fields.OnFieldChanged.emit(this.field);
  }
}
